require('./customer-file')


// WEBPACK FOOTER //
// ./src/mock/services/list/index.js